import { injectable } from "tsyringe";
import { WARD_CONFIGURATION } from "api/ApiPath";
import client from "api/client";
import { IWardConfigurationRepository } from "../domain/repositories/IWardConfigurationRepository";
import { WardConfigurationListRequestModel } from "./model/WardConfigurationListRequestModel";
import { WardConfigurationFormRequestModel } from "./model/WardConfigurationFormRequestModel";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { WardConfigurationResponseEntity } from "../domain/entities/WardConfigurationResponseEntity";

@injectable()
export class WardConfigurationImpl implements IWardConfigurationRepository {
  async getList(
    params: WardConfigurationListRequestModel,
  ): Promise<ListBaseApiResponseModel<WardConfigurationResponseEntity>> {
    return await client.get(WARD_CONFIGURATION.LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<WardConfigurationResponseEntity>> {
    return await client.get(WARD_CONFIGURATION.DETAIL, params);
  }

  async create(
    body: WardConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<WardConfigurationResponseEntity>> {
    return await client.post(WARD_CONFIGURATION.CREATE, body);
  }

  async update(
    body: WardConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<WardConfigurationResponseEntity>> {
    return await client.put(WARD_CONFIGURATION.UPDATE, body);
  }

  async delete(params: {
    id: string;
  }): Promise<BaseApiResponseModel<WardConfigurationResponseEntity>> {
    return await client.delete(WARD_CONFIGURATION.DELETE, params);
  }
}
